export * from "./accordion";
export * from "./auction-object-page";
export * from "./auction-watch";
export * from "./auctions-list-page/auctionBid";
export * from "./auctions-list-page/AuctionListPage";
export * from "./auctions-list-page/LatestAuctionLots";
export * from "./basket/addItemToBasket";
export * from "./bottom-menu";
export * from "./cartBadge/getBasketAmount";
export * from "./checkout/checkout";
export * from "./consent/consentHandler";
export * from "./currencies";
export * from "./favorites";
export * from "./forgotPassword/passwordRecovery";
export * from "./forgotPassword/paswordChange";
export * from "./images-carousel";
export * from "./index.scss";
export * from "./login-register";
export * from "./modal";
export * from "./my-page";
export * from "./my-page/sub-pages/EditUserInfo";
export * from "./my-page/invoice/Invoice";
export * from "./my-page/my-orders/MyOrders";
export * from "./notifications/OutBidNotification";
export * from "./order-confirmation";
export * from "./product-list-page";
export * from "./product-page";
export * from "./quantitySelector";
export * from "./shopping-cart";
export * from "./singleStamp";
export * from "./utils/grid-items/grid-product-listing";
export * from "./utils/image-zoom";
export * from "./components/SaveSearchModal";
export * from "./auction-hall/AuctionHall";
export * from "./modal/TipFriend";
export * from "./customer-context-switcher/CustomerContextSwitcher";
export * from "./components/GoTopButton";
export * from "./hotJarCondition";
export * from "./googleAnalyticsCondition";
export * from "./blog/BlogFeedPage";
const CHRISTIANIA_TEST_AUCTION_IDS = [100193];
(function () {
    const match = window.location.pathname.match(/^\/(?:en\/auctions|auksjon)\/(\d+)(?:\/|$)/);
    if (!match) {
        return;
    }
    const auctionId = parseInt(match[1], 10);
    if (CHRISTIANIA_TEST_AUCTION_IDS.includes(auctionId)) {
        document.body.classList.add('christiania-test');
    }
})();
